module.exports = __webpack_public_path__ + "img/Nicole+Jon-46.1ea5a6ff.jpg";